<template>
  <div>
    <div class="text-disabled mb-4">
      Система аналізує всі подачі інформації щодо боржника до Кредитного реєстру
      за ідентифікатором і відображає повну історію за весь період використання
      системи: коли подавалися дані, які активи (забезпечення) було припинено та
      які залишаються діючими.
    </div>

    <b-input
      v-model="credentials.debtorId"
      placeholder="Введіть ідентифікатор боржника, напр. 53b8e707-6fdd-11ee-98e6-000c295a1b77"
      :error-messages="getErrorMessages(v$.debtorId)"
      @blur="v$.debtorId.$touch()"></b-input>
  </div>
</template>

<script lang="ts">
import { reactive } from 'vue'
import { required, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { getErrorMessages } from 'best-modules/utils'
import { debtorChronologyReport } from '@/request/report'

const uuidRegex =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/

export default {
  name: 'DebtorChronology',
  methods: { getErrorMessages },
  setup() {
    const credentials = reactive<{ debtorId: string }>({
      debtorId: '',
    })

    const rules = {
      debtorId: {
        required,
        uuid: helpers.withMessage(
          'Некоректний ідентифікатор боржника',
          (value: string) => uuidRegex.test(value.trim())
        ),
      },
    }
    const v$ = useVuelidate(rules, credentials)

    const submit = () => {
      return debtorChronologyReport(credentials.debtorId.trim())
    }

    return { credentials, v$, submit }
  },
}
</script>

<style scoped lang="scss"></style>
